import React from 'react';
import { useIntegrations } from '~/contexts';
import SyncIcon from './SyncIcon';
import XeroGrey from './XeroGrey';
import QBOGrey from '~/routes/app/projects/assets/qbo-grey.svg?react';

export default function AccountingIntegrationIcon() {
  const integrations = useIntegrations();

  if (integrations.qbo && integrations.xero) return <SyncIcon />;
  if (integrations.qbo) return <QBOGrey style={{ width: '1rem', height: '1rem' }} />;
  return <XeroGrey />;
}
